import { UserStatus, ModelTypes } from 'types/types';

export const ROOT_URL =
  // @ts-ignore
  window.env_vars?.REACT_APP_ROOT_URL ?? process.env.REACT_APP_ROOT_URL;
export const API_VERSION = 'api/v1' as const;
export const DRAWER_WIDTH = 240 as const;

export const USER_STATUSES = [
  {
    value: UserStatus.active,
    i18nLabelKey: 'users.status.active',
  },
  {
    value: UserStatus.inactive,
    i18nLabelKey: 'users.status.inactive',
  },
  {
    value: UserStatus.pending,
    i18nLabelKey: 'users.status.pending',
  },
] as const;

export const API_URLS: { [key in ModelTypes]?: string } = {
  [ModelTypes.subProject]: 'projects/:projectId/subProjects/:id',
  [ModelTypes.role]: 'projects/:projectId/subProjects/:id/roles',
  [ModelTypes.user]: 'projects/:projectId/users/:id',
  [ModelTypes.patient]: 'projects/:projectId/patients/:id',
  [ModelTypes.userSignUp]: 'user/registerUser',
  [ModelTypes.visit]: 'patients/:patientId/visits/:id',
  [ModelTypes.visitTemplate]: 'projects/:projectId/visitTemplates/:id',
  [ModelTypes.formTemplateType]: 'projects/:projectId/formTemplateTypes/:id',
  [ModelTypes.form]: 'visits/:visitId/forms/:id',
  [ModelTypes.formTemplate]:
    'formTemplateTypes/:formTemplateTypeId/formTemplates/:id',
  [ModelTypes.formTemplateForms]: 'projects/:projectId/forms',
  [ModelTypes.codeLibraries]: 'projects/:projectId/codeLibraries',
  [ModelTypes.codeLibraryOption]:
    'projects/:projectId/codeLibraries/:id/options',
  [ModelTypes.fieldTemplate]: 'projects/:projectId/fieldTemplates/:id',
  [ModelTypes.comment]: 'comments',
};
